try {
  class SearchBar extends HTMLElement {
    constructor() {
      super();

      this.container = this;

      this.toggle = this.querySelector('.header__search-toggle');
      this.input = this.querySelector('.header__search-input');
      this.form = this.querySelector('.header__search-form');

      this.toggle.addEventListener('click', this.open.bind(this));

      this.toggle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.open.bind(this);
        }
      });
    }

    open(e) {
      if (this.toggle.getAttribute('aria-expanded') == 'true') {
        this.form.submit();
      } else {
        this.container.classList.add('open');
        this.toggle.setAttribute('aria-expanded', true);

        this.input.focus();
      }
    }

    close() {
      this.container.classList.remove('open');
      this.toggle.setAttribute('aria-expanded', false);
    }
  }

  customElements.define('search-bar', SearchBar);
} catch (e) {}
